import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import vueToast from "./plugins/vueToast"
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);

import './assets/css/app.css'

Vue.config.productionTip = false
Vue.use(require('vue-jalali-moment'));
new Vue({
  router,
  store,
  vuetify,
  vueToast,
  render: h => h(App)
}).$mount('#app')
